<template>
  <div class="build-info" v-if="!!info">
    <button id="build-info-btn" type="button" class="btn btn-sm btn-dark rounded-circle">
      <i class="fa fa-info"></i>
    </button>
    <b-popover
      target="build-info-btn"
      title="Current build info"
      triggers="hover focus"
    >
      <dl>
        <dt>Build time</dt>
        <dd>{{info.time | localTime}}</dd>
        <dt v-if="info.branch">Branch</dt>
        <dd v-if="info.branch">{{info.branch}}</dd>
        <dt v-if="info.lastCommitHash">Last commit <small>({{info.lastCommitHash}})</small></dt>
        <dd v-if="info.lastCommitMessage">
          <pre>{{info.lastCommitMessage}}
          </pre>
        </dd>
      </dl>
    </b-popover>
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: null
    }
  },
  mounted() {
    // TODO: show only in test env
    if ( process.env.VUE_APP_BUILD_INFO /*&& process.env.NODE_ENV == 'test'*/ ) {
      try {
        this.info = JSON.parse(process.env.VUE_APP_BUILD_INFO);
      } catch(e){};
    }
  },
  filters: {
    localTime: (date) => (new Date(date)).toLocaleString()
  }
}
</script>

<style lang="scss">
.build-info {
  position: fixed;
  z-index: 123456;
  bottom: 10px;
  right: 10px;
  .btn {
    width: 28px;
  }
}
</style>
